import React from 'react';
import { PropertyGrid, TabPane, Checkbox, Pane, Label, NumericInput } from '@leverege/ui-elements';
import { ItemEditor } from '@leverege/ui-attributes';
import { ModelTypeSelector } from '@leverege/ui-plugin';
import { Plugins } from '@leverege/plugin';
import { ns } from '@leverege/i18n';
import XYChartModel from "../models/XYChartModel.js";
import S from './RolloverEditor.css';
import useDefaultRollover from "../hooks/useDefaultRollover.js";
const {
  t
} = ns('ui-attributes-graphs.editors.RolloverEditor');
export default function RolloverEditor(props) {
  const {
    value,
    onChange: pOnChange,
    eventData,
    objectType
  } = props;
  const onChange = evt => {
    const {
      value: v,
      data
    } = evt;
    if (data === 'setRollover' && hasDetails(v)) {
      pOnChange({
        data: {
          setRollover: 'rollover',
          setRolloverVisible: 'visible'
        },
        value: {
          rollover: v,
          visible: true
        }
      });
    } else {
      pOnChange(evt);
    }
  };
  const rollover = useDefaultRollover(XYChartModel.getRollover(value), objectType);
  return /*#__PURE__*/React.createElement(TabPane, {
    className: S.editor
  }, /*#__PURE__*/React.createElement(TabPane.Tab, {
    tabName: t('details'),
    tabId: "details"
  }, /*#__PURE__*/React.createElement(ItemEditor, {
    value: rollover,
    onChange: onChange,
    eventData: eventData,
    showDisplayOptions: false
  })), /*#__PURE__*/React.createElement(TabPane.Tab, {
    tabName: t('options'),
    tabId: "options"
  }, /*#__PURE__*/React.createElement(PropertyGrid, {
    variant: "rolloverOptionsEditor|editor"
  }, /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: /*#__PURE__*/React.createElement(Checkbox, {
      label: t('visible'),
      value: XYChartModel.getRolloverVisible(value),
      eventData: "setRolloverVisible",
      onChange: onChange
    })
  }), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: /*#__PURE__*/React.createElement(Checkbox, {
      label: t('snapX'),
      value: XYChartModel.getSnapToDatumX(value),
      eventData: "setSnapToDatumX",
      onChange: onChange
    })
  }), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: /*#__PURE__*/React.createElement(Checkbox, {
      label: t('snapY'),
      value: XYChartModel.getSnapToDatumY(value),
      eventData: "setSnapToDatumY",
      onChange: onChange
    })
  }), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: /*#__PURE__*/React.createElement(Checkbox, {
      label: t('verticalCrosshair'),
      value: XYChartModel.getShowHorizontalCrosshair(value),
      eventData: "setShowHorizontalCrosshair",
      onChange: onChange
    })
  }), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: /*#__PURE__*/React.createElement(Checkbox, {
      label: t('horizontalCrosshair'),
      value: XYChartModel.getShowVerticalCrosshair(value),
      eventData: "setShowVerticalCrosshair",
      onChange: onChange
    })
  }), /*#__PURE__*/React.createElement(PropertyGrid.Divider, null)), /*#__PURE__*/React.createElement(PropertyGrid, null, /*#__PURE__*/React.createElement(PropertyGrid.Header, {
    title: t('glyph')
  }), ModelTypeSelector.createSelectorAndEditor({
    values: Plugins.get('GlyphModel'),
    value: XYChartModel.getGlyph(value),
    eventData: 'setGlyph',
    onChange,
    allowNone: false,
    isPropertyGrid: true,
    modelKey: 'model',
    label: t('type'),
    editorProps: {
      objectType
    }
  }))));
}
function hasDetails(rollover) {
  const types = rollover?.types;
  if (!types) {
    return false;
  }
  const key = Object.keys(types)[0];
  const details = types[key]?.details?.details;
  return details?.length > 0;
}